import './automatic_refresh_time.js.coffee';# Added by Script
class Customer.AutomaticRefreshTimeCollection extends Backbone.Collection
  model: Customer.AutomaticRefreshTime

  defaultRefreshTime: =>
    @getTimeByID("2")

  getTimeByID: (id) =>
    @findWhere(id: id)

  getTimeByName: (name) =>
    @findWhere(name: name)
